<template>
  <div class="discovery-item" v-if="visible_c">
    <div class="item">
      <div class="head">
        <div class="head-left">
          <div
            class="avatar"
            :style="{ backgroundImage: 'url(' + avatar_c + ')' }"
          ></div>
          <div class="title">
            <div class="tit van-ellipsis">
              {{ source.name }}
              <span v-if="source.articleType === 'NOTICE'">官方公告</span>
              <span v-if="source.articleType === 'NEW'">新人成长</span>
            </div>
            <div class="time" v-if="source.createTime">
              <template v-if="dayjs(source.createTime).year() < dayjs().year()">
                {{ dayjs(source.createTime).format('YYYY年') }}
              </template>
              {{ dayjs(source.createTime).format('MM月DD日') }}
            </div>
          </div>
        </div>
        <div
          class="btn van-hairline--surround"
          @click="copy(source.desc)"
        >
          复制文案
        </div>
      </div>
      <div class="content">
        <div class="desc">
          <span v-if="source.desc_fold && !source.fold">{{
            source.desc_fold
          }}</span>
          <span v-else>{{ source.desc }}</span>
          <span
            class="btn"
            v-show="source.desc_fold && !source.fold"
            @click="foldToggle(source)"
            >展开</span
          >
          <span
            class="btn"
            v-show="source.desc_fold && source.fold"
            @click="foldToggle(source)"
            >收起</span
          >
        </div>
        <div class="imgs clearfix">
          <div
            class="img-wrapper"
            v-for="(item, index) in source.urls"
            :key="source.id + index"
          >
            <div class="img" @click="imagePreviewOpen(index)">
              <img :src="item" alt="" />
            </div>
          </div>
        </div>
        <div class="goods" v-if="source.goodsId" @click="toGoodsDetail">
          <div
            class="img"
            :style="{
              backgroundImage: 'url(' + source.goodsImage + ')',
            }"
          ></div>
          <div class="text">
            <div class="title van-ellipsis">
              {{ source.goodsName }}
            </div>
            <div class="amount">
              <span class="prefix">¥</span>
              <span class="value">{{ source.actPrice }}</span>
              <span class="unline">省赚¥{{ source.saveProfit }}</span>
            </div>
          </div>
        </div>
        <div class="footer">
          <div
            class="favorites"
            @click="favoritesToggle(source, source.id, source.isLike, source.articleType)"
          >
            <img
              :src="require('@/assets/activityplace/favorites_active.png')"
              alt=""
              v-if="source.isLike"
            />
            <img
              :src="require('@/assets/activityplace/favorites.png')"
              alt=""
              v-else
            />
            <span>喜欢</span>
          </div>
          <div class="btns">
            <div class="btn van-hairline--surround" @click="downloadImages">
              下载图片
            </div>
            <div class="btn btn-link van-hairline--surround" @click="forward" v-if="source.articleType === 'FODDER'">转发</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview, Toast } from 'vant'
import { favorites, favoritesCancel, sharePoster, getActivityDetail } from '@/api/discovery'
export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    avatar_c() {
      return this.source['avatar'] || require('@/assets/setting/avatar.png')
    },
    visible_c() {
      // 如果是我的-喜欢列表中数据，隐藏取消喜欢的
      if (this.source.likeList && !this.source.isLike) {
        return false
      }
      return true
    }
  },
  methods: {
    foldToggle(source) {
      source.fold = !source.fold
    },
    imagePreviewOpen(index) {
      ImagePreview({
        images: this.source.urls,
        startPosition: index,
        closeable: true,
      })
    },
    downloadImages() {
      Toast('请长按图片，保存到手机')
    },
    copy(message) {
      try {
        const input = document.createElement('input')
        input.value = message        
        document.body.appendChild(input)
        input.setAttribute('readonly','readonly')
        input.select()
        input.setSelectionRange(0, input.value.length), document.execCommand('Copy')
        document.body.removeChild(input)
        Toast.success('已复制到剪切板')
      } catch (error) {
        Toast.fail('复制失败')
      }
    },
    favoritesToggle(source, id, flag, type) {
      const params = { fodderId: id, type }
      if (flag) {
        favoritesCancel(params).then((res) => {
          source.isLike = false
        })
      } else {
        favorites(params).then((res) => {
          source.isLike = true
        })
      }
    },
    toGoodsDetail() {
      // 判断商品是否在活动中
      // 缺少 this.source.actId
      // getActivityDetail(this.source.actId)
      //   .then(res => {
      //     console.log('res', res)
          
      //   })
      this.$router.push({ name: 'DiscoveryGoodsDetail', params: { id: this.source.partGoodsId } })
    },
    forward() {
      const forwardUrl = `${window.location.origin}/read-article?id=${this.source.id}&type=0&customerId=${this.$store.state.user.forwardId}`
      const params = {
        imgUrls: this.source.urls,
        content: this.source.content,
        partGoodsId: this.source.partGoodsId,
        fodderId: this.source.id,
        forwardUrl,
      }
      this.$store.dispatch('app/showLoading')
      sharePoster(params)
        .then(res => {
          this.$store.dispatch('app/hideLoading')
          this.sharePosterOpen(res.data, forwardUrl)
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    sharePosterOpen(url, forwardUrl) {
      this.$store.dispatch('sharePoster/show', {
        url,
        title: this.source.goodsName,
        desc: this.source.content,
        link: forwardUrl,
        imgUrl: this.source.goodsImage
      })
    },
  },
}
</script>

<style lang="less" scoped>
.discovery-item {
  text-align: left;
  background-color: #fff;
  margin-bottom: 24px;
  .item {
    padding: 22px 20px 26px;
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .head-left {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;
        .avatar {
          width: 84px;
          height: 84px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          border-radius: 100%;
        }
        .title {
          padding-left: 20px;
          .tit {
            font-size: 24px;
            font-weight: 600;
            color: #3a3a3a;
            line-height: 30px;
          }
          .time {
            padding-top: 4px;
            font-size: 20px;
            font-weight: 400;
            color: #aeaeae;
            line-height: 26px;
          }
        }
      }
      .btn {
        font-size: 24px;
        font-weight: 400;
        color: #e82035;
        line-height: 1em;
        padding: 10px 26px;
        &::after {
          border-color: #e82035;
          border-radius: 48px;
        }
      }
    }
    .content {
      .desc {
        font-size: 22px;
        font-weight: 400;
        color: #333333;
        line-height: 1.4em;
        .btn {
          color: #aeaeae;
          margin-left: 8px;
        }
      }
      .imgs {
        padding-top: 20px;
        .img-wrapper {
          float: left;
          width: 32.4%;
          margin-right: 1.4%;
          margin-bottom: 1.4%;
          &:nth-of-type(3n) {
            margin-right: 0;
          }
          .img {
            position: relative;
            width: 100%;
            padding-top: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
      .goods {
        padding-top: 16px;
        display: flex;
        .img {
          width: 80px;
          height: 80px;
          border-radius: 12px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
        }
        .text {
          flex: 1;
          min-width: 0;
          padding-left: 20px;
          .title {
            font-size: 24px;
            font-weight: 600;
            color: #333333;
            line-height: 40px;
          }
          .amount {
            padding-top: 12px;
            display: flex;
            align-items: flex-end;
            .prefix {
              font-size: 24px;
              line-height: 1em;
              font-weight: 800;
              color: #e82035;
            }
            .value {
              font-size: 32px;
              line-height: 1em;
              font-weight: 800;
              color: #e82035;
            }
            .unline {
              font-size: 20px;
              color: #e82035;
              line-height: 1em;
              line-height: 24px;
              margin-left: 8px;
            }
          }
        }
      }
      .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;
        .favorites {
          display: flex;
          align-items: center;
          img {
            width: 44px;
            height: 44px;
          }
          span {
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            margin-left: 12px;
          }
        }
        .btns {
          .btn {
            display: inline-block;
            font-size: 24px;
            font-weight: 400;
            color: #e82035;
            line-height: 1em;
            width: 156px;
            text-align: center;
            padding: 10px 0;
            &::after {
              border-color: #e82237;
              border-radius: 48px;
            }
            & + .btn {
              margin-left: 12px;
            }
            &.btn-link {
              background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
              border-radius: 48px;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .share-poster-container {
    display: block;
    & /deep/ .poster {
      width: 100%;
      height: 100%;
      padding: 50px 0;
      overflow-y: auto;
      text-align: center;
      img {
        width: 550px;
        margin: 0 auto;
      }
    }
  }
}
</style>